/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get, ember/require-computed-property-dependencies */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { isArray } from '@ember/array';
import { computed } from '@ember/object';
import { sort, alias } from '@ember/object/computed';
import { service } from '@ember/service';
import moment from 'moment';
import { filterBy } from '@linc-technologies/linced-common/utils/arrays';

export default class UnexplainedController extends Controller {
  @service
  attendanceCodes;

  @computed('model.{date,period}')
  get title() {
    let formattedDate = moment(this.model.date.date, 'YYYY-MM-DD').format(
      'dddd Do MMMM, YYYY',
    );
    return `Absences pending explanation for ${formattedDate} (${this.model.period.longName})`;
  }

  @computed('model.records.@each.code')
  get absentees() {
    let unknownCode = this.get('attendanceCodes.unknown.code');
    let records = this.model.records;

    if (isArray(records)) {
      return filterBy(records, 'code', unknownCode);
    } else {
      return [];
    }
  }

  @alias('absentees.length')
  numAbsentees;

  @tracked sortProp = 'person.lastName';
  @tracked sortDir = 'asc';

  get sort() {
    if (this.sortDir === 'asc') {
      return [this.sortProp];
    }
    return [`${this.sortProp}:${this.sortDir}`];
  }

  @sort('absentees', 'sort')
  sortedAbsentees;
}
